<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'ContractModule',
        props: {},
        components:{},
        data: () => ({

        }),
        computed: {},
        watch: {},
        methods: {},
        mounted() {}
    }
</script>
